import './styles/main.scss';
import { determineDeviceFromBody } from './js/utility/mobileDetect';
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import { initClientStatisticSlider } from './js/post/clientStatisticSlider';
import { initLightBoxSlider } from './js/post/lightBoxSlider';
import { toggleAccordion } from './js/page/archive';
import { initSliderFullWidthAutoplay } from './js/post/sliderFullWidthAutoplay';
import { initSliderFullWidthNav } from './js/post/sliderFullWidthNav';
window.Stimulus = Application.start();
var context = require.context("./js/controllers", true, /\.js$/);
window.Stimulus.load(definitionsFromContext(context));
window.debug = process.env.NODE_ENV === 'development';
window.addEventListener('DOMContentLoaded', function (e) {
    var statisticSlider = document.querySelectorAll('.swiper');
    statisticSlider.forEach(function (slider) {
        var sliderId = slider.getAttribute('id');
        if (sliderId === 'testimonial-slider-red')
            return;
        var dataDirection = slider.getAttribute('data-direction');
        if (sliderId)
            initClientStatisticSlider(sliderId, (dataDirection ? dataDirection : 'horizontal'));
    });
    determineDeviceFromBody();
    initLightBoxSlider();
    toggleAccordion('.accordion');
    initSliderFullWidthAutoplay('.team-swiper');
    initSliderFullWidthNav('.testimonial-slider');
});
